<template>
  <div class="pay">
    <div class="pay-container">
      <div class="pay__content">
        <div class="content__info">
          <!--         header-->
          <div class="Header_header">
            <div class="Header_header__top">
              <div class="Header_top__logo">
                <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 91 104" fill="currentColor">
                  <path
                      d="M87.71 24.5805L48.2 1.77055C46.42 0.740547 44.2 0.740547 42.41 1.77055L2.9 24.5805C1.11 25.6105 0 27.5305 0 29.6005V75.2206C0 77.2806 1.11 79.2005 2.9 80.2405L42.41 103.051C43.29 103.561 44.29 103.821 45.31 103.821C46.33 103.821 47.33 103.551 48.21 103.051L87.72 80.2405C89.51 79.2105 90.62 77.2906 90.62 75.2206V29.6005C90.62 27.5405 89.51 25.6205 87.72 24.5805H87.71ZM46.2 49.5805C45.65 49.9005 44.96 49.9005 44.41 49.5805L6 27.4105L44.41 5.24055C44.95 4.93055 45.66 4.93055 46.2 5.24055L84.61 27.4105L46.2 49.5805V49.5805ZM42.41 53.0405C42.69 53.2005 42.99 53.3405 43.31 53.4505V98.9305L4.9 76.7705C4.35 76.4505 4 75.8606 4 75.2206V30.8705L42.41 53.0405V53.0405Z"
                      fill="currentColor"></path>
                </svg>
                <span>crypto-pay</span></div>
            </div>
          </div>
          <!--          header-->
          <div class="payment-details">
            <div class="payment-details__wrapper">
              <div class="payment-details__amount_wrapper">
                <span class="payment-details__amount">{{displayTokenAmount}}</span>
                <span class="payment-details__amount" v-if="token">{{token?.name}}</span></div>
              <div class="copy-icon" v-show="token" @click="copy(this.displayTokenAmount)">
                <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
                     class="icon-wrapper">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M8.82961 6.92431e-07L8.86815 4.05779e-06H11.8028L11.8413 6.92431e-07H11.8414H11.8414C12.3685 -1.47793e-05 12.8233 -2.81246e-05 13.1978 0.0305736C13.5931 0.0628745 13.9864 0.13419 14.3647 0.326985C14.9292 0.614605 15.3882 1.07355 15.6758 1.63803C15.8686 2.01641 15.9399 2.40963 15.9722 2.80498C16.0028 3.17955 16.0028 3.63432 16.0028 4.16148V4.2V8.30206V8.34058C16.0028 8.86774 16.0028 9.32251 15.9722 9.69709C15.9399 10.0924 15.8686 10.4857 15.6758 10.864C15.3882 11.4285 14.9292 11.8875 14.3647 12.1751C13.9864 12.3679 13.5931 12.4392 13.1978 12.4715C12.9447 12.4922 12.655 12.4989 12.331 12.501C12.3337 12.2946 12.3336 12.0809 12.3336 11.8648L12.3336 11.801V10.5009C12.6268 10.4988 12.8498 10.4933 13.0349 10.4781C13.3066 10.4559 13.4073 10.4183 13.4568 10.3931C13.6449 10.2972 13.7979 10.1442 13.8938 9.95605C13.919 9.9066 13.9566 9.80589 13.9788 9.53422C14.002 9.25088 14.0028 8.87861 14.0028 8.30206V4.2C14.0028 3.62345 14.002 3.25118 13.9788 2.96784C13.9566 2.69618 13.919 2.59546 13.8938 2.54601C13.7979 2.35785 13.6449 2.20487 13.4568 2.109C13.4073 2.0838 13.3066 2.04613 13.0349 2.02393C12.7516 2.00078 12.3793 2 11.8028 2H8.86815C8.2916 2 7.91932 2.00078 7.63599 2.02393C7.36432 2.04613 7.2636 2.0838 7.21416 2.109C7.04196 2.19674 6.89922 2.33231 6.80276 2.49891H4.73303C4.77603 2.20725 4.85219 1.91856 4.99513 1.63803C5.28275 1.07355 5.74169 0.614605 6.30618 0.326985C6.68456 0.13419 7.07778 0.0628745 7.47312 0.0305735C7.84767 -2.81258e-05 8.30239 -1.47793e-05 8.82949 6.92431e-07H8.82953H8.82961ZM4.1999 3.4989L4.16136 3.4989H4.16136C3.63421 3.49889 3.17945 3.49887 2.80488 3.52947C2.40953 3.56178 2.01631 3.63309 1.63793 3.82589C1.07345 4.11351 0.614504 4.57245 0.326884 5.13693C0.13409 5.51531 0.0627738 5.90853 0.0304728 6.30388C-0.000130135 6.67844 -0.000115429 7.13319 -9.83815e-05 7.66032V7.66036V7.69891V11.801V11.8395V11.8395C-0.000115429 12.3667 -0.000130136 12.8214 0.0304728 13.196C0.0627738 13.5913 0.13409 13.9846 0.326884 14.3629C0.614504 14.9274 1.07345 15.3864 1.63793 15.674C2.01631 15.8668 2.40953 15.9381 2.80487 15.9704C3.17945 16.001 3.63422 16.001 4.16138 16.001H4.1999H7.13452H7.17304C7.7002 16.001 8.15497 16.001 8.52955 15.9704C8.9249 15.9381 9.31811 15.8668 9.69649 15.674C10.261 15.3864 10.7199 14.9274 11.0075 14.3629C11.2003 13.9846 11.2717 13.5913 11.304 13.196C11.3346 12.8214 11.3345 12.3667 11.3345 11.8395V11.8395V11.801V7.6989V7.66038V7.66035C11.3345 7.13321 11.3346 6.67845 11.304 6.30388C11.2717 5.90853 11.2003 5.51531 11.0075 5.13693C10.7199 4.57245 10.261 4.11351 9.69649 3.82589C9.31811 3.63309 8.9249 3.56178 8.52955 3.52947C8.15498 3.49887 7.70022 3.49889 7.17307 3.4989H7.17307L7.13452 3.4989H4.1999ZM2.54591 5.6079C2.59536 5.58271 2.69608 5.54503 2.96774 5.52283C3.25108 5.49968 3.62335 5.4989 4.1999 5.4989H7.13452C7.71108 5.4989 8.08335 5.49968 8.36669 5.52283C8.63835 5.54503 8.73907 5.58271 8.78851 5.6079C8.97668 5.70377 9.12966 5.85675 9.22553 6.04491C9.25072 6.09436 9.2884 6.19508 9.31059 6.46674C9.33375 6.75008 9.33452 7.12235 9.33452 7.6989V11.801C9.33452 12.3775 9.33375 12.7498 9.31059 13.0331C9.2884 13.3048 9.25072 13.4055 9.22553 13.4549C9.12966 13.6431 8.97668 13.7961 8.78851 13.892C8.73907 13.9172 8.63835 13.9548 8.36669 13.977C8.08335 14.0002 7.71108 14.001 7.13452 14.001H4.1999C3.62335 14.001 3.25108 14.0002 2.96774 13.977C2.69608 13.9548 2.59536 13.9172 2.54591 13.892C2.35775 13.7961 2.20477 13.6431 2.1089 13.4549C2.0837 13.4055 2.04603 13.3048 2.02383 13.0331C2.00068 12.7498 1.9999 12.3775 1.9999 11.801V7.69891C1.9999 7.12235 2.00068 6.75008 2.02383 6.46674C2.04603 6.19508 2.0837 6.09436 2.1089 6.04491C2.20477 5.85675 2.35775 5.70377 2.54591 5.6079Z"
                        fill="currentColor"></path>
                </svg>
              </div>
            </div>
            <div class="payment-details__menu ">
              <div class="menu__info">
                <div class="payment-details__subheading">
                  <div class="subheading__currency">
                    <span style="margin-right: 1vw" v-show="amount">{{amount}}</span>
                    <span>RMB</span>
                  </div>
                  <span v-if="token">网络 · {{token.network}}</span>
                  <span v-else>选择网络</span>
                </div>
                <div class="payment-details__fee">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_3533_30846)">
                      <path
                          d="M10 18.3332C14.6024 18.3332 18.3334 14.6022 18.3334 9.99984C18.3334 5.39746 14.6024 1.6665 10 1.6665C5.39765 1.6665 1.66669 5.39746 1.66669 9.99984C1.66669 14.6022 5.39765 18.3332 10 18.3332Z"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      <path d="M10 13.3333V10" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round"></path>
                      <path d="M10 6.6665H10.0067" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round"></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_3533_30846">
                        <rect width="20" height="20" fill="white"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                  <span>您支付网络费用</span></div>
              </div>
              <div class="HeaderMenu_container">
                <button class="HeaderMenu_icon__btn__fIiYR HeaderMenu_non_action__6tIdU" data-debug="true"
                        data-testid="crms-tooltop" trianglemobileposition="17" triangleposition="2" dir="ltr">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M21 11.25V19.5C21 20.3284 20.3284 21 19.5 21H5.25C4.42157 21 3.75 20.3284 3.75 19.5V11.25M12 4.875C12 3.42525 10.8247 2.25 9.375 2.25C7.92525 2.25 6.75 3.42525 6.75 4.875C6.75 6.32475 7.92525 7.5 9.375 7.5C10.1095 7.5 12 7.5 12 7.5M12 4.875C12 5.59024 12 7.5 12 7.5M12 4.875C12 3.42525 13.1753 2.25 14.625 2.25C16.0747 2.25 17.25 3.42525 17.25 4.875C17.25 6.32475 16.0747 7.5 14.625 7.5C13.8905 7.5 12 7.5 12 7.5M12 7.5V21M3.375 11.25H21.375C21.9963 11.25 22.5 10.7463 22.5 10.125V8.625C22.5 8.00368 21.9963 7.5 21.375 7.5H3.375C2.75368 7.5 2.25 8.00368 2.25 8.625V10.125C2.25 10.7463 2.75368 11.25 3.375 11.25Z"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </button>
                <button class="HeaderMenu_icon__btn__fIiYR" data-debug="true" data-testid="faq-tooltop"
                        trianglemobileposition="0" triangleposition="0" dir="ltr">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M9.16504 8.6212C9.44483 8.01091 9.92016 7.51137 10.5158 7.20164C11.1115 6.8919 11.7934 6.78967 12.4537 6.91111C12.906 6.98051 13.3358 7.15501 13.7084 7.42059C14.0811 7.68616 14.3863 8.03542 14.5995 8.44032C14.753 8.76417 14.8363 9.11683 14.8438 9.47514C14.8514 9.83344 14.783 10.1893 14.6432 10.5193C14.5035 10.8493 14.2955 11.146 14.0329 11.3899C13.7703 11.6338 13.4591 11.8194 13.1197 11.9344C12.7734 12.0658 12.4739 12.2968 12.2588 12.5982C12.0437 12.8996 11.9227 13.258 11.9111 13.6281"
                        stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"></path>
                    <path d="M11.8877 17.1387H11.8955" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round"></path>
                    <path
                        d="M12 22C17.5229 22 22 17.5229 22 12C22 6.47716 17.5229 2 12 2C6.47716 2 2 6.47716 2 12C2 17.5229 6.47716 22 12 22Z"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </button>
                <div class="HeaderMenu_menu__BGHrB">
                  <button class="HeaderMenu_icon__btn__fIiYR">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M7.82806 4.54352C7.77611 4.41811 7.78133 4.30439 7.88048 4.14829C7.99687 3.96506 8.23058 3.764 8.54543 3.62884C8.86107 3.49334 9.1564 3.46749 9.35393 3.51036C9.51181 3.54462 9.6081 3.61467 9.67567 3.7778C10.5329 5.84731 13.4645 5.84763 14.3218 3.77788C14.3738 3.65253 14.4578 3.57589 14.6382 3.53567C14.85 3.48845 15.1573 3.51158 15.4755 3.6387C15.7945 3.76613 16.0217 3.95675 16.1311 4.1268C16.2185 4.26276 16.237 4.38043 16.1695 4.54351C15.312 6.61374 17.3859 8.68628 19.4554 7.82907C19.6187 7.76144 19.7364 7.78002 19.8724 7.86745C20.0424 7.97681 20.233 8.2039 20.3604 8.52286C20.4874 8.84102 20.5105 9.14841 20.4632 9.36024C20.423 9.54068 20.3463 9.62486 20.2207 9.67687C18.1515 10.534 18.1498 13.466 20.2203 14.3236C20.3833 14.3911 20.4534 14.4874 20.4877 14.6454C20.5306 14.843 20.5047 15.1384 20.3693 15.454C20.2342 15.7689 20.0332 16.0027 19.8501 16.119C19.6941 16.2181 19.5805 16.2233 19.4552 16.1714C17.3853 15.3141 15.313 17.3876 16.1701 19.4568C16.2221 19.5822 16.2168 19.6959 16.1177 19.8519C16.0014 20.035 15.7677 20.236 15.4528 20.3711C15.1371 20.5065 14.8418 20.5324 14.6442 20.4895C14.4862 20.4551 14.3898 20.385 14.3222 20.2219C13.4648 18.1518 10.5326 18.1521 9.67525 20.222C9.62328 20.3475 9.53914 20.4242 9.35869 20.4644C9.14685 20.5117 8.83944 20.4886 8.52126 20.3615C8.20228 20.2341 7.97517 20.0436 7.86581 19.8736C7.77839 19.7377 7.75982 19.62 7.82742 19.4568C8.68455 17.3875 6.6122 15.3137 4.54215 16.1711C4.41685 16.223 4.30323 16.2178 4.14719 16.1187C3.96401 16.0023 3.76298 15.7686 3.62784 15.4537C3.49236 15.138 3.46651 14.8427 3.50939 14.6451C3.54366 14.4872 3.61372 14.3909 3.77675 14.3234C5.84702 13.4659 5.84534 10.5341 3.77631 9.67704C3.65075 9.62503 3.57406 9.54088 3.53382 9.36049C3.48657 9.1487 3.50968 8.84133 3.63678 8.52318C3.7642 8.20423 3.9548 7.97713 4.12487 7.86776C4.26084 7.78031 4.37862 7.76174 4.54189 7.82937C6.6116 8.68667 8.68563 6.61387 7.82806 4.54352ZM11.5234 3.01243C11.1807 2.18494 10.5122 1.71515 9.77806 1.55585C9.08362 1.40515 8.35982 1.53202 7.75648 1.79103C7.15234 2.05038 6.56723 2.48562 6.19225 3.07597C5.80004 3.69346 5.64136 4.49063 5.9803 5.30889C6.15573 5.73242 5.73143 6.15731 5.30726 5.98161C4.47977 5.63885 3.67484 5.77928 3.04304 6.1856C2.44533 6.57 2.0231 7.17145 1.7795 7.78121C1.53559 8.39178 1.42951 9.1133 1.5818 9.79595C1.74109 10.51 2.19265 11.1859 3.01094 11.5248C3.43504 11.7005 3.43423 12.3005 3.01139 12.4756C2.18391 12.8184 1.71417 13.4869 1.55488 14.221C1.40419 14.9154 1.53101 15.6391 1.78995 16.2425C2.04924 16.8466 2.48439 17.4318 3.07468 17.8068C3.69211 18.1991 4.48925 18.3578 5.30752 18.0189C5.73064 17.8436 6.15523 18.2675 5.97966 18.6914C5.6369 19.5189 5.77738 20.3238 6.18378 20.9556C6.56823 21.5532 7.16973 21.9754 7.77951 22.2189C8.39008 22.4627 9.11159 22.5687 9.79421 22.4164C10.5082 22.2571 11.1841 21.8056 11.523 20.9873C11.6986 20.5634 12.299 20.5635 12.4745 20.9873C12.8172 21.8147 13.4857 22.2845 14.2198 22.4439C14.9142 22.5947 15.638 22.468 16.2414 22.2091C16.8456 21.9498 17.4308 21.5147 17.8058 20.9244C18.1981 20.3069 18.3568 19.5097 18.0179 18.6915C17.8424 18.2678 18.2668 17.844 18.6898 18.0192C19.5081 18.3581 20.3052 18.1994 20.9227 17.8071C21.5129 17.432 21.948 16.8468 22.2073 16.2427C22.4662 15.6393 22.5929 14.9155 22.4422 14.2211C22.2828 13.4871 21.8131 12.8185 20.9856 12.4758C20.5626 12.3006 20.5618 11.7004 20.9861 11.5246C21.8043 11.1857 22.2559 10.5098 22.4152 9.79582C22.5676 9.11318 22.4616 8.39165 22.2177 7.78106C21.9742 7.17127 21.552 6.56979 20.9543 6.18535C20.3225 5.77898 19.5176 5.63855 18.6901 5.98131C18.266 6.15696 17.8419 5.73218 18.0172 5.30887C18.36 4.4814 18.2195 3.67652 17.8131 3.04481C17.4287 2.44719 16.8272 2.02501 16.2175 1.78143C15.607 1.53752 14.8855 1.43141 14.2029 1.5836C13.4889 1.7428 12.813 2.19423 12.4741 3.01251C12.2987 3.43585 11.6989 3.436 11.5234 3.01243ZM9.99992 12C9.99992 10.8954 10.8954 9.99998 11.9999 9.99998C13.1045 9.99998 13.9999 10.8954 13.9999 12C13.9999 13.1046 13.1045 14 11.9999 14C10.8954 14 9.99992 13.1046 9.99992 12ZM11.9999 7.99998C9.79078 7.99998 7.99992 9.79084 7.99992 12C7.99992 14.2091 9.79078 16 11.9999 16C14.2091 16 15.9999 14.2091 15.9999 12C15.9999 9.79084 14.2091 7.99998 11.9999 7.99998Z"
                            fill="currentColor"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <expire-component v-if="!displayExpire"  style="background-color: #fff; margin-top: 3vw;"/>
          </div>
          <check-out v-if="checkOut" :token="token" @copy="copy"></check-out>
          <check-status v-if="checkStatus"></check-status>
          <crypto-selection v-if="!cryptoSelection" @token="updateToken" :amount="amount"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import checkOut from "@/components/crypto/checkOut";
import checkStatus from "@/components/crypto/checkStatus";
import ExpireComponent from "@/components/crypto/expireComponent";
import cryptoSelection from "@/components/crypto/cryptoSelection";
import {showSuccessToast} from "vant";
import {copyToClipboard} from "@/utils/ecode"

export default {
  name: "cryptoPayPage",
  data() {
    return {
      user:this.$store.getters.getUser,
      expire: false,
      amount:null,
      token:null,
      interval:null
    }
  },
  components: {
    ExpireComponent,
    checkOut,
    checkStatus,
    cryptoSelection
  },
  computed:{
    checkStatus(){
      return this.expire;
    },
    checkOut(){
      return this.token && !this.expire;
    },
    displayTokenAmount(){
      return this.token?this.token?.actualAmount:"选择代币"
    },
    displayExpire(){
      return this.token || this.expire
    },
    cryptoSelection(){
      return this.token || this.expire
    }
  },
  methods:{
    updateToken(res){
      this.token=res;
    },
    async checkOrder(tradeID){
      try {
        const res = await this.$user_http.get(`/user/checkCryptoPayStatus?trade_id=${tradeID}`);
        if (res.data?.code==0) {
          this.user.balance.remaining += this.amount
          this.$store.commit('updateUser', this.user);
          showSuccessToast("充值成功！")
          this.$router.push({name:'user'})
          return
        }
      } catch (error) {
        console.error("获取视频列表失败：", error);
      }
    },
    copy(text){
      copyToClipboard(text)
    }
  },
  watch:{
    token(v){
      if (v.tradeID && !this.interval) {
        this.interval = setInterval(async ()=>{
          if (v.expirationTime<Date.now()){
            this.expire = true
            clearInterval(this.interval);
            this.interval = null;
            return;
          }
          console.log("---------------------:"+v.expirationTime)
          await this.checkOrder(v.tradeID)
        }, 5000)
      }
    }
  },
  mounted() {
    if (!this.$route.query.amount) {
      this.$router.push({ name: 'NotFound' });
      return
    }
    this.amount = this.$route.query.amount
  },
  beforeUnmount() {
    clearInterval(this.interval)
  }
}
</script>

<style scoped lang="scss">
.pay {
  min-height: 120vh;
  background-color: #fff;
  color: #000;
  .pay-container {
    align-items: center;
    display: flex;
    flex-direction: column;
    row-gap: 24px;
    padding: 0 16px;
  }
  .pay__content {
    box-sizing: border-box;
    color: #000;
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 40px;

    .content__info {
      background: linear-gradient(247.95deg, #ededed 5.87%, #f6f6f6 96.55%);
      display: flex;
      flex-direction: column;
      gap: 32px;

      .Header_header__top {
        display: flex;
        gap: 16px;
        justify-content: space-between;

        .Header_top__logo {
          align-items: center;
          display: flex;
          font-family: Biennale, Golos, sans-serif;
          font-size: 28px;
          font-weight: 600;
          gap: 8px;
          grid-area: logo;
          letter-spacing: -.59px;
          line-height: 36px;
        }
      }

      .payment-details {
        display: flex;
        flex-direction: column;
        padding: 0 32px;
        .payment-details__wrapper {
          align-items: center;
          display: flex;
          gap: 8px;
          margin-bottom: 3vw;

          .payment-details__amount_wrapper {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;

            .payment-details__amount {
              align-items: center;
              display: flex;
              font-size: 36px;
              font-weight: 600;
              gap: 8px;
              line-height: 44px;
              word-break: break-all;
            }
          }

          .copy-icon {
            background: #fff;
            border-radius: 40px;
            box-shadow: 0px 0px 20px #0000001a, 0px 0px 6px #0000000a;
            color: var(--contentPrimary);
            cursor: pointer;
            flex-shrink: 0;
            height: 44px;
            position: relative;
            transition: all .3s ease;
            width: 44px;
            align-items: center;
            display: flex;
            justify-content: center;
          }
        }
        .payment-details__menu {
          align-items: flex-end;
          display: flex;
          flex-flow: row nowrap;
          justify-content: space-between;

          .payment-details__subheading {
            column-gap: 6px;
            display: flex;
            flex-direction: column;
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;

            .subheading__currency {
              margin-bottom: 2vw;
            }
          }

          .payment-details__fee {
            align-items: center;
            color: #666;
            display: flex;
            gap: 8px;
            margin-top: 16px;
          }
        }
      }

      .HeaderMenu_container {
        column-gap: 16px;
        display: flex;
        flex-flow: row nowrap;
        position: relative;

        .HeaderMenu_icon__btn__fIiYR {
          align-items: center;
          background: #ffffff;
          border: none;
          border-radius: 50%;
          cursor: pointer;
          display: flex;
          height: 40px;
          justify-content: center;
          transition: all .3s ease;
          width: 40px;
        }
      }

    }
  }
  @media only screen and (max-width: 460px) {
    .pay-container {
      padding: 0;
    }
    .pay__content {
      background-color: #0000;
      border-radius: 0;
      box-shadow: none;
      margin: 0;
      padding: 0;
    }
    .content__info {
      border-radius: 0;

      .Header_header {
        padding: 3vw 3vw 0;

        .Header_header__top {
          align-items: flex-start;
          flex-direction: column;
          row-gap: 24px;
        }
      }

      .payment-details {
        padding: 0 3vw !important;

        .payment-details__amount {
          font-size: 26px !important;
          line-height: 36px !important;
        }
      }

      .payment-details__menu {
        align-items: flex-start !important;
        flex-direction: column !important;
        row-gap: 24px !important;

        .payment-details__subheading {
          margin-top: 2vw;
        }

        .payment-details__fee {
          margin-top: 2vw !important;
        }
      }

      .content__actions {
        border-radius: 0 !important;
        padding: 6vw 3vw !important;
      }

      .confirm__text {
        max-width: 60% !important;
      }
    }
    .status-container{
      padding: 0 3vw;
    }
    .status-hint__heading-text{
      font-size: 16px!important;
    }
  }

}
</style>
